export default __webpack_public_path__ + "static/media/local-grocery-store@2x.10d07548.svg";